import { ProcedureStepCommentService as OvermapProcedureStepCommentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepCommentService extends OvermapProcedureStepCommentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
